<template>
    <div>
        <input type="hidden" name="id" :value="item_hash">
        <div class="coupon" v-if="user_data">
            <g-loading v-show="is_loading.coupon" :full_view="false"></g-loading>
            <div class="coupon-box" :class="{ selected: selected_coupon !== null }" @click="openCouponList" v-show="!is_loading.coupon">
                <span class="c-icon is-coupon is-current-color"></span>
                <div class="text-container">
                    <div v-show="selected_coupon" class="selected-text">選択済み</div>
                    <div class="u-text-ellipsis">{{ getSelectedCouponName }}</div>
                </div>
                <div class="arrow-container" v-show="!in_cart && !has_other_subscribe">
                    <span class="c-icon" :class="{ 'open': is_open, 'is-stroke-right': !invalid_coupon}"></span>
                </div>
                <input type="hidden" name="coupon_code" :value="getSelectedCouponCode">
            </div>
            <div v-if="has_other_subscribe" class="warning">
                別の定期購読が買い物かごに入っています。<br>買い物かごでクーポンの変更が可能です。
            </div>
            <div v-else-if="in_cart" class="warning">
                このアイテムはカートに追加済みです。<br>買い物かごでクーポンの変更が可能です。
            </div>
            <div v-show="is_open">
                <div class="price-radio-box justify-center no-top-border">
                    <input class="custom-radio" type="radio" id="coupon_unselected" v-model="selected_coupon" :value="null" />
                    <label for="coupon_unselected">クーポン解除</label>
                </div>
                <div v-for="user_coupon in this.user_coupon_list" class="price-radio-box">
                    <input class="custom-radio" type="radio" :id="user_coupon.activate_code" v-model="selected_coupon" :value="user_coupon" />
                    <label :for="user_coupon.activate_code">
                        <div class="coupon-title u-mt-1">{{ user_coupon.COUPON_NAME }}</div>
                        <p v-if="user_coupon.FOR_ALL_ITEMS" class="coupon-detail">種別：{{ user_coupon.discount_value }}OFF</p>
                        <p v-else class="coupon-detail">種別：{{ getDiscountValue(user_coupon.DISCOUNT_PRICE) }}</p>
                        <p class="coupon-detail">クーポンコード：{{ user_coupon.activate_code }}</p>
                        <p class="coupon-detail" v-show="user_coupon.dsp_usage_end_date">有効期限：{{ user_coupon.dsp_usage_end_date }}まで有効</p>
                    </label>
                </div>
            </div>
        </div>
        <div class="login-button" v-else v-show="!is_loading.coupon">
            <a class="c-round-btn is-full-width" @click="redirectLogin">ログインしてクーポンを見る</a>
        </div>
        <div v-show="!is_loading.price">
            <div v-show="(isPlusUser & !item_detail.is_media_do_contents || item_detail.is_campaign && item_detail.is_media_do_contents)">
                <div v-show="item_detail.is_campaign" class="sale-label u-mb-4">
                    <span class="price-title">セール中</span>
                    <span class="c-label is-pink" v-show="item_detail.is_campaign">{{ item_detail.discount_string }}OFF</span>
                </div>
                <div>
                    <p v-if="!item_detail.is_media_do_contents" class="price-title u-mb-3">週プレ プラス！会員価格</p>
                    <span class="c-price-and-tax is-big is-orange">
                        <span class="c-price_value">￥{{ item_detail.current_tax_price }}</span>
                        <span class="c-price_tax">（税込）</span>
                        <template v-if="!item_detail.is_media_do_contents">
                            <span v-if="parseInt(item_detail.current_tax_price) && !item_detail.is_subscription" class="c-label is-orange">{{ item_detail.total_discount_string }}OFF</span>
                        </template>
                    </span>
                    <div v-show="item_detail.is_campaign" class="c-discount-expires u-mt-2" style="--icon-size: 14px;">
                        <span class="c-icon is-time is-current-color"></span>{{ getSalesEndDateFormat }}JST まで
                    </div>
                </div>
            </div>
            <div v-show="!isPlusUser">
                <div class="price-radio-box">
                    <input class="custom-radio" type="radio" id="current_price" name="price" value="0" v-model="selected_plus" />
                    <label for="current_price">
                        <div class="price">
                            <span class="c-price-and-tax is-big" :class="{ 'is-pink': item_detail.is_campaign }">
                                <span class="c-price_value">￥{{item_detail.current_tax_price }}</span>
                                <span class="c-price_tax">（税込）</span>
                            </span>
                            <span class="c-label is-pink" v-show="item_detail.is_campaign">{{ item_detail.discount_string }}OFF</span>
                        </div>
                        <div v-show="item_detail.is_campaign">
                            <p class="now-sale">セール開催中！</p>
                            <div class="c-discount-expires u-mt-2" style="--icon-size: 14px;"><span class="c-icon is-time is-current-color"></span>{{ getSalesEndDateFormat }}JST まで</div>
                        </div>
                    </label>
                </div>
                <div v-if="!item_detail.is_media_do_contents" class="price-radio-box">
                    <input class="custom-radio" type="radio" id="current_plus_price" name="price" value="1" v-model="selected_plus" />
                    <label for="current_plus_price">
                        <div>週プレ プラス！会員登録でさらに{{ item_detail.plus_discount_string }}OFF</div>
                        <div class="price u-mt-2">
                            <span class="c-price-and-tax is-big is-orange">
                                <span class="c-price_value">￥{{ item_detail.current_tax_plus_price }}</span>
                                <span class="c-price_tax">（税込）</span>
                            </span>
                            <span v-if="parseInt(item_detail.current_tax_price) && (!item_detail.is_subscription && !item_detail.is_media_do_contents)" class="c-label is-orange">{{ item_detail.total_discount_string }}OFF</span>
                        </div>
                        <div v-show="item_detail.is_campaign" class="c-discount-expires" style="--icon-size: 14px;">
                            <span class="c-icon is-time is-current-color"></span>{{ getSalesEndDateFormat }}JST まで
                        </div>
                        <ul class="discount-rate" v-show="discount_rate">
                            <li class="c-discount-message">
                                <span class="c-icon is-check is-current-color check-icon"></span>
                                <p>
                                    <span class="c-discount-message_emphasize">会員登録</span>でデジタル写真集が即時<span class="c-discount-message_emphasize">{{ discount_rate.min }}％OFF</span>
                                </p>
                            </li>
                            <li class="c-discount-message">
                                <span class="c-icon is-check is-current-color check-icon"></span>
                                <p>
                                    さらに<span class="c-discount-message_emphasize">会員継続</span>でデジタル写真集が最大<span class="c-discount-message_emphasize">{{ discount_rate.max }}％OFF</span>
                                </p>
                            </li>
                            <li v-if="item_detail.plus_extra_message" class="c-discount-message">
                                <span class="c-icon is-check is-current-color check-icon"></span>
                                <p class="c-discount-message__plus_extra_message" v-html="item_detail.plus_extra_message"></p>
                            </li>
                            <li class="c-discount-message">
                                <span class="c-icon asterisk-icon">※</span>
                                <p>
                                    週プレ プラス！会員は今なら初回<span class="c-discount-message_emphasize">30日間無料</span>！<br>(クレジッドカード決済限定)
                                </p>
                            </li>
                        </ul>
                    </label>
                </div>
            </div>
        </div>
        <g-loading v-show="is_loading.price" :full_view="false"></g-loading>
        <div class="l-even-width-blocks buttons m-bottom-20">
            <a v-if="in_cart" class="c-round-btn is-positive" :href="route(route_list, 'site.cart')">買い物かごを見る</a>
            <button v-else class="c-round-btn is-positive" type="submit" name="payment_type" value="add">買い物かごに追加</button>
            <!-- プラス会員を選択されたときに変更するようにする -->
            <template v-if="showPlusButton">
                <button class="c-round-btn" type="button" name="payment_type" @click="clickPlusButton" >会員登録して購入</button>
            </template>
            <template v-else>
                <a v-if="in_cart" class="c-round-btn" :href="route(route_list, 'site.payment')" data-cy="buy-now-button">購入手続きへ</a>
                <button v-else class="c-round-btn" type="submit" name="payment_type" value="buy" data-cy="buy-now-button">購入手続きへ</button>
            </template>
        </div>
        <plus-subscription-modal ref="subscription_modal" v-show="show_modal" @close="closeModal"
            @complete="subscriptionComplete" :is_maintenance="is_maintenance" :route_list="route_list" :redirect_route="redirect_route">
        </plus-subscription-modal>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import routeMixin from '../../../mixins/route.js';

export default {
    props: {
        route_list: Object,
        item_hash: String,
        redirect_route: Object,
        is_complete: Number,
        in_cart : Boolean,
        cart: null,
        cart_coupon: String,
        invalid_coupon: Boolean,
        has_other_subscribe: false,
        is_plus_selected: false,
        is_maintenance: Boolean,
    },
    mixins: [routeMixin],
    data() {
        return {
            user_coupon_list: null,
            coupon_list: null,
            is_open: false,
            selected_coupon: null,
            selected_plus: 0,
            user_data: null,
            show_modal: false,
            discount_rate: {
                min : '',
                max : '',
            },

            item_detail: {
                price: null,
                is_campaign: null,
                sale_end_date: null,
                discount_string: "",
                plus_discount_string: "",
                total_discount_string: "",
            },

            is_loading: {
                coupon: true,
                price: true,
            },
        }
    },
    created() {
        this.setUserData();
        this.setDiscountRate();
    },
    mounted() {
        if(this.is_complete) {
            this.openModalComp();
        }
        this.initCouponList(true);
        if (this.is_plus_selected) {
            this.selected_plus = '1';
        }
    },
    computed: {
        getSelectedCouponName: function () {
            if (this.invalid_coupon) {
                return '使えるクーポンはありません';
            }
            if (this.in_cart && this.coupon_list) {
                let coupon_code = this.cart[this.item_hash].coupon_code;
                if(!coupon_code) {
                    return '使えるクーポンがあります';
                }
                let selected_name = '使えるクーポンがあります';
                this.coupon_list.forEach(coupon => {
                    if(coupon.activate_code === coupon_code) {
                        selected_name = coupon.COUPON_NAME;
                    }
                });
                return selected_name
            }
            return this.selected_coupon ? this.selected_coupon.COUPON_NAME : '使えるクーポンがあります';
        },
        getSelectedCouponCode: function () {
            return this.selected_coupon ? this.selected_coupon.activate_code : '';
        },
        isPlusUser: function () {
            return this.user_data ? this.user_data.is_plus : false;
        },
        getSalesEndDateFormat: function () {
            return this.item_detail.campaign_end_date ? moment(this.item_detail.campaign_end_date).format('YYYY/MM/DD HH:mm ') : '';
        },
        showPlusButton: function () {
            return this.selected_plus === "1" && !this.isPlusUser;
        },
        empty_coupon : function() {
            return (this.coupon_list && this.coupon_list.length <= 0)
        }
    },
    watch: {
        selected_coupon: function () {
            this.is_open = false;
            this.setItemPrice();
        },
        coupon_list: {
            handler: function() {
                this.getSelectedCouponName;
                this.empty_coupon;
            },
            deep: true
        }
    },
    methods: {
        setUserData: function () {
            this.is_loading.coupon = true;
            let url = this.route(this.route_list, 'site.api.user.plusInfo');
            axios.get(url, {
                params: {
                }
            }).then(res => {
                this.user_data = res.data.data;
                this.is_loading.coupon = false;
                this.setItemPrice();
            }).catch(error => {
                this.is_loading.coupon = false;
                this.setItemPrice();
            });
        },
        openCouponList: function () {
            if(this.in_cart || this.invalid_coupon) {
                return;
            }
            if (this.user_data && !this.user_coupon_list) {
                this.initCouponList();
                return;
            }
            this.is_open = !this.is_open;
        },
        initCouponList: function (from_mount = false) {
            let params = {
                'params': {
                    hash: this.item_hash,
                    exclude_cart_coupon: true,
                }
            }
            if (!from_mount) {
                this.is_open = false;
            } else {
                params = {'params': {hash: this.item_hash}}
            }
            let url = this.route(this.route_list, 'site.api.user.myCouponList');
            axios.get(url, params).then(res => {
                if (!from_mount) {
                    this.user_coupon_list = res.data.data.user_coupon_list;
                    this.is_open = true;
                } else {
                    this.coupon_list = res.data.data.user_coupon_list;
                }
            }).catch(error => {
                if (!from_mount) {
                    this.user_coupon_list = [];
                    this.is_open = false;
                } else {
                    this.coupon_list = [];
                }
            });
        },
        setItemPrice: async function () {
            this.is_loading.price = true;
            let url = this.route(this.route_list, 'site.api.item.detail', {
                'hash'   : this.item_hash,
                'coupon' : this.selected_coupon ? this.selected_coupon.activate_code : '',
            });
            await axios.get(url, {
                params: {
                }
            }).then(res => {
                this.item_detail = res.data.data
                this.is_loading.price = false;
            }).catch(error => {
                this.is_loading.price = false;
            });
        },
        setDiscountRate: function () {
            this.is_loading.coupon = true;
            let url = this.route(this.route_list, 'site.api.plus.subscription.discountRateMinMax');
            axios.get(url, {
                params: {
                }
            }).then(res => {
                this.discount_rate = res.data.data
            }).catch(error => {
            });
        },
        clickPlusButton: function () {
            if (this.user_data) {
                this.openModal();
            } else {
                this.redirectLogin();
            }
        },
        redirectLogin: function () {
            let current_url = window.location.pathname;
            let url = this.route(this.route_list, 'site.signin', { 'backUrl': current_url });
            window.location.href = url;
        },
        openModal: function () {
            this.$refs.subscription_modal.initModal();
            this.show_modal = true;
        },
        closeModal: function () {
            this.show_modal = false;
        },
        openModalComp: function () {
            this.$refs.subscription_modal.openComp();
            this.show_modal = true;
        },
        subscriptionComplete: function () {
            this.closeModal();
            this.selected_plus = false;
            this.setUserData();
        },
        getDiscountValue: function (discount) {
            let price = this.item_detail.current_base_price - discount;
            price = price.toLocaleString("ja-JP", { style: "currency", currency: "JPY" });
            return price + ' OFF';
        },
    }
}
</script>

<style lang="scss" scoped>
.coupon-box {
    --icon-size: 24px;
    height: 56px;
    padding: 8px 15px;
    border: 1px solid var(--gj-border-color);
    font-size: 14px;
    font-weight: 600;
    line-height: 130%;
    color: var(--gj-color-light-grey);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    cursor: pointer;

    .text-container {
        width: calc(100% - var(--icon-size) * 2 - 16px);

        .selected-text {
            color: var(--gj-color-blue);
        }
    }

    .c-icon.is-stroke-right {
        transform: rotate(90deg);
        transition: transform 0.2s;

        &.open {
            transform: rotate(-90deg);
        }
    }

    &.selected {
        color: var(--gj-text-color);

        .c-icon.is-coupon {
            color: var(--gj-color-blue);
        }
    }
}

.price-radio-box {
    padding: 16px 15px;
    border: 1px solid var(--gj-border-color);
    display: flex;
    gap: 8px;

    &:not(:first-child) {
        border-top: none;
    }

    &.no-top-border {
        border-top: none;
    }

    .custom-radio {
        flex: 0 0 auto;
        appearance: none;
        border: 1px solid #b7c5cb;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        position: relative;
        opacity: 1;
        cursor: pointer;
        pointer-events: unset;

        &:checked {
            border-color: var(--gj-color-blue);

            &::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 18px;
                height: 18px;
                border-radius: 50%;
                background-color: var(--gj-color-blue);
            }
        }
    }
    label {
        display: flex;
        flex-direction: column;
        justify-content: center;
        line-height: 130%;
        gap: 2px;
        color: var(--gj-text-color);
        font-size: 14px;
        font-weight: 600;
        line-height: 130%;
        flex: 1 1 auto;

        .coupon-title {
            font-size: 14px;
            font-weight: 600;
            line-height: 130%;
            margin-bottom: 8px;
        }
        .coupon-detail {
            color: var(--gj-text-color-light);
            font-size: 11px;
            font-weight: 300;
            line-height: 130%;

            &.alert {
                font-size: 10px;
                color: var(--gj-color-red);
            }
        }
        .discount-rate {
            list-style: none;
            margin-top: 12px;
        }
        .now-sale {
            color: var(--gj-color-pink);
            font-size: 11px;
            font-weight: 600;
            line-height: 130%;
        }
    }
}

.price {
    display: flex;
    align-items: center;
}

.price-title {
    color: var(--gj-text-color);
    font-size: 14px;
    font-weight: 600;
    line-height: 130%;
}

.sale-label {
    display: flex;
    align-items: center;
    gap: 8px;
}

.check-icon {
    --icon-size: 14px;
    color: var(--gj-color-orange);
}

.login-button-container {
    border: 1px solid var(--gj-border-color);
    border-top: none;
    padding: 16px 15px;
}

.buttons {
    margin-top: 24px;
    gap: 8px;

    @media (min-width: 768px) {
        gap: 16px;
    }
}
.coupon-activate-wrapper {
    margin: 24px 0;
}
.warning {
    margin-top: 10px;
    font-size: 15px;
    font-weight: 600;
    line-height: 130%;
    color: var(--gj-color-red);
}

.login-button {
    margin-bottom: 24px;
}

.m-bottom-20 {
    margin-bottom: 20px;
}

:where(button, a).c-round-btn.submit-button {
    width: 295px;
    display: block;
    margin-inline: auto;
    @media (min-width: 768px) {
        width: 100%;
    }
}

.about-attention {
    font-size: 12px;
    font-weight: 300;
    color: var(--gj-color-red);
    line-height: 18.2px;
    text-align: start;
    padding-left: 1em;
    padding-top: 1em;
}

.cancel-link {
    margin-block: 17px;
    font-size: 12px;
}

.to-pre-order-link {
    margin-top: 40px;
    @media (min-width: 768px) {
        margin-top: 24px;
    }
}

</style>
